import { css } from '@emotion/css';
const container = css `
  display: grid;
  grid-gap: 16px;
  max-width: 620px;
`;
const colorInputContainer = css `
  max-width: 289px;
`;
const text = css `
  margin-bottom: 4px;
`;
export const ColorStyles = {
    container,
    colorInputContainer,
    text,
};
//# sourceMappingURL=Color.styles.js.map